import {FormProps} from "../shared/types";
import {AutocompleteInput, ReferenceInput, SimpleForm, TextInput} from "react-admin";
import {initInput} from "../shared/utils";


export const NotificationChatIdForm = (props: FormProps) => {
    return (
        <SimpleForm {...props}>
            <ReferenceInput
                {...initInput("user", props.fieldOptions)}
                reference="autocomplete/user"
                label="Utente"
            >
                <AutocompleteInput optionText="label" />
            </ReferenceInput>
            <TextInput {...initInput("info", props.fieldOptions)} />
        </SimpleForm>
    )
}